import { useEffect, useState } from "react";
import PageHero from "@/components/feature/PageHero";
import { classLevels } from "@/mocks/classes";
import LevelSection from "./components/LevelSection";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Classes() {
  const [active, setActive] = useState("elementary");

  useEffect(() => {
    const onScroll = () => {
      let nearestId = classLevels[0].id;
      let nearestDistance = Infinity;
      classLevels.forEach((l) => {
        const el = document.getElementById(l.id);
        if (!el) return;
        const distance = Math.abs(el.getBoundingClientRect().top - 120);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestId = l.id;
        }
      });
      setActive(nearestId);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <PageHero
        tag="CLASSES"
        title={
          <>
            학년별로 다른
            <br />
            <span className="text-primary-500">맞춤 커리큘럼</span>
          </>
        }
        description="초등부·중등부·고등부, 학년과 목표에 따라 가장 효과적인 수업을 설계합니다. 한 반 최대 6명의 소수정예로 밀착 관리합니다."
        image="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20layered%20glowing%20lime%20green%20geometric%20shapes%20and%20smooth%20graph%20curves%20floating%20over%20a%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=720&seq=mbhj-classes-hero-01&orientation=landscape"
      />

      <nav className="sticky top-16 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur-md md:top-20">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="flex items-center gap-1 overflow-x-auto py-3">
            <div className="flex w-fit items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
              {classLevels.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-bold transition-colors cursor-pointer ${
                    active === l.id
                      ? "bg-primary-500 text-foreground-950"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`}
                >
                  {l.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>

      <LevelSection level={classLevels[0]} dark={false} flip={false} />
      <LevelSection level={classLevels[1]} dark flip />
      <LevelSection level={classLevels[2]} dark={false} flip={false} />

      <ConsultCTA />
    </>
  );
}